/**
 * @param {object} input
 * @param {number} input.x
 * @param {number} input.y
 * @param {number} input.hotspotRadius
 * @param {number} input.cardWidth
 * @param {number} input.cardHeight
 * @param {{ width: number, height: number }} input.viewport
 * @param {number} [input.gap]
 * @param {number} [input.margin]
 * @param {number} [input.topInset]
 */
export function calculateCardPosition({
  x,
  y,
  hotspotRadius,
  cardWidth,
  cardHeight,
  viewport,
  gap = 24,
  margin = 16,
  topInset = margin,
}) {
  const minTop = Math.max(margin, topInset);
  const maxTop = Math.max(minTop, viewport.height - cardHeight - margin);
  const top = Math.min(Math.max(y - cardHeight / 2, minTop), maxTop);
  let left = x + hotspotRadius + gap;

  if (left + cardWidth > viewport.width - margin) {
    left = x - hotspotRadius - gap - cardWidth;
  }

  left = Math.min(
    Math.max(left, margin),
    viewport.width - cardWidth - margin,
  );

  return { left, top };
}
